import { Api } from 'models/services/api';
import { CreateSatelliteKitchenQuery } from 'models/services/graphql';

import { SatelliteKitchenData, SatelliteKitchenDataToSave } from '../index';

type DataToCreate = {
  centralKitchenId: string;
  input: SatelliteKitchenDataToSave;
};

const RequestQuery = `
  mutation CreateSatelliteKitchen($centralKitchenId: ID!, $input: SatelliteKitchenInput!) {
    ${CreateSatelliteKitchenQuery}
  }
`;

type ResponseData = {
  data: {
    createSatelliteKitchen: SatelliteKitchenData
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly document?: SatelliteKitchenData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.createSatelliteKitchen;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { CreateGql };